import { createContext, useContext, useState } from 'react';

const AdminPreviewContext = createContext({ previewMode: 'b2c', setPreviewMode: () => {} });

export function AdminPreviewProvider({ children }) {
  const [previewMode, setPreviewMode] = useState('b2c');
  return (
    <AdminPreviewContext.Provider value={{ previewMode, setPreviewMode }}>
      {children}
    </AdminPreviewContext.Provider>
  );
}

export function useAdminPreview() {
  return useContext(AdminPreviewContext);
}
